import { camelizeKeys, decamelizeKeys } from "humps";
import { PartnerAddress, PartnerAddressPayload } from "../types/partner-addresses.types";

export const fetchGetUserAddresses = async (
  token: string
): Promise<PartnerAddress[]> => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/ms/user/user-addresses`,
    {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      } as { [key: string]: string },
    }
  );
  if (response.status === 200) {
    const responseJson = await response.json();
    return camelizeKeys(responseJson) as PartnerAddress[];
  } else {
    throw new Error();
  }
};

export const fetchUpdateUserAddresses = async (
  token: string,
  data: PartnerAddressPayload
): Promise<PartnerAddress> => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/ms/user/user-addresses`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      } as { [key: string]: string },
      body: JSON.stringify(decamelizeKeys(data)),
    }
  );
  if (response.status === 200) {
    const responseJson = await response.json();
    return camelizeKeys(responseJson) as PartnerAddress;
  } else {
    throw new Error();
  }
};

export const fetchDeleteUserAddresses = async (
  token: string,
  data: PartnerAddress
): Promise<boolean> => {
  const response = await fetch(
    `${process.env.REACT_APP_BASE_URL}/api/ms/user/user-addresses/${data.id}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
      } as { [key: string]: string },
    }
  );
  if (response.status === 200 || response.status === 202) {
    return true;
  } else {
    throw new Error();
  }
};
